var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iconify-holder shaded-bg",class:{welled: _vm.well}},[_c('div',{key:_vm.iconClass,staticClass:"iconify"},[_c('i',{class:_vm.iconClass})]),_vm._v(" "),_vm._t("default",[_vm._v("\n\t\tInformación no disponible\n\t")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }